import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9 3.478 5.83 6.253l-.33.123H3v5h2.5l.33.124L9 14.274V3.478ZM5.312 5.376 9.171 2l.829.376v13l-.83.377-3.858-3.377H2.5l-.5-.5v-6l.5-.5h2.812Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.524 14.371a6.988 6.988 0 0 0 2.662-5.494 6.988 6.988 0 0 0-2.662-5.495l-.631.776a5.99 5.99 0 0 1 2.293 4.719 5.99 5.99 0 0 1-2.293 4.718l.631.776Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M11.631 12.043a3.993 3.993 0 0 0 1.555-3.166 3.991 3.991 0 0 0-1.555-3.166L11 6.487a2.995 2.995 0 0 1 1.186 2.39c0 .975-.465 1.841-1.186 2.39l.631.776Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }